import { Image as ImageIcon, X } from "lucide-react";

export const ReferencePanel = ({ referencePreview, onFileChange, onClear }) => (
    <div className="border border-white/10 bg-surface p-5">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/60 flex items-center gap-2 mb-3">
            <ImageIcon className="w-3 h-3 text-blaze" />
            Reference Image (Optional)
        </div>
        {referencePreview ? (
            <div className="relative group">
                <img
                    src={referencePreview}
                    alt="Reference"
                    className="w-full aspect-square object-cover border border-white/10"
                    data-testid="reference-preview"
                />
                <button
                    onClick={onClear}
                    className="absolute top-2 right-2 w-7 h-7 bg-black/70 border border-white/20 flex items-center justify-center hover:bg-blaze hover:border-blaze transition-colors"
                    data-testid="clear-reference-button"
                >
                    <X className="w-3.5 h-3.5" />
                </button>
            </div>
        ) : (
            <label
                className="block border border-dashed border-white/15 hover:border-white/40 bg-obsidian aspect-square cursor-pointer transition-colors group"
                data-testid="reference-upload-label"
            >
                <input
                    type="file"
                    accept="image/*"
                    onChange={onFileChange}
                    className="hidden"
                    data-testid="reference-upload-input"
                />
                <div className="w-full h-full flex flex-col items-center justify-center gap-3 text-white/40 group-hover:text-white/70 transition-colors">
                    <ImageIcon className="w-8 h-8" />
                    <span className="font-mono text-[10px] uppercase tracking-[0.25em]">
                        Click to upload
                    </span>
                    <span className="font-mono text-[9px] text-white/30 px-3 text-center leading-relaxed">
                        Map a character or face onto yourself
                    </span>
                </div>
            </label>
        )}
    </div>
);
